import React from "react"
import { 
    latest as API_URL, 
    host as ROOT_DIR 
} from "../../../config/api";
import { isActiveSlide, positionLeft, panels } from "../../../config/Helpers";
import { Icon } from 'antd';

//Modulos
import TopProducers from "./views/TopProducers";
import Production from "./views/Production";
import Reserves from "./views/Reserves";
import FiltersActive from "./../../../components/FiltersActive";

const postUrlLogin = API_URL + "widgets";

class Layout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            response_request : [],
            request_status : "hide",
            active_slide : {},
            slides : {},
            slides_component : "",
            tab_submodule : 'inactive',
            tab_filters : 'inactive',
            panels : panels()
        }
        this.setDefaultValuesModule = this.setDefaultValuesModule.bind(this);
        this._setStart = this._setStart.bind(this)
        this.getResetValues = this.getResetValues.bind(this)
    }
    setDefaultValuesModule(){
        let $self = this;
        this._Reserves.setDefaultValues();
        this._Production.setDefaultValues();
        this.setState({
            response_request : [],
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        }, $self.props.app.mainRequest())
    }
    getResetValues(){
        this._Reserves.setDefaultValues();
        this._Production.setDefaultValues();
        return {
            response_request : [],
            request_status   : "hide",
            active_slide : {}, 
            slides : {},
            tab_submodule : 'inactive',
            tab_filters : 'inactive',
            panels : panels  
        }
    }
    activeSubmoduleTab() {
        this.setState(function(){
            const state = (this.state.tab_submodule === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : state,
                tab_filters : 'inactive'
             }
        })
    }
    activeFiltersTab() {
        this.setState(function(){
            const state = (this.state.tab_filters === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : 'inactive',
                tab_filters : state
             }
        })
    }
    activeSlide(slide){
        this.setState(function(prev){
            if(prev.activeSlide !== slide.key){
                return {
                    active_slide : slide
                }
            }
        })
    }
    _setStart(start_touch){
        let $self = this;
        $self.setState({
            touch_values : { start : start_touch }
        });
        setTimeout(function(){
            $self.setState({
                touch_values : { start : 0 }
            });
        }, 500);
    }
    componentWillReceiveProps(props) {
        let response    = props.app.state.reservation_response_request, self = this;
        this.setState({
            response_request : response,
        })
    }
    componentWillUpdate(){
    }

    render() {
        if(this.props.app.state.panel === "reservation"){
            let panel = "reservation", 
            panel_dashboards = this.props.app.state.mode_report._dashboards_select,
            self = this, 
            panels = this.state.panels

            this.state.slides_component = Object.keys(panels).map((key) => {
                let index = -1;
                if(panels[key].value === panel){
                    let dashboards = panels[key].dashboards;
                    return (Object.keys(dashboards).map((key_aux) => {
                        let dashboard_include = false;
                        if(self.props.app.state.mode_report.status === true && self.props.app.state.mode_report._is_share === true){
                            Object.keys(panel_dashboards).map((key) => {
                                let _decode = JSON.parse(panel_dashboards[key]);
                                if(_decode._dashboard === dashboards[key_aux].value){
                                    dashboard_include = true
                                }
                            })
                        }else{
                            dashboard_include = true
                        }
                        if(dashboard_include === true){
                            index++;
                            if(index === 0 && self.state.active_slide.key === undefined){
                                self.state.active_slide.key = dashboards[key_aux].value
                                self.state.active_slide.index = dashboards[key_aux].index
                            }
                            return (
                                <div 
                                    className={isActiveSlide(self.state.active_slide.key, dashboards[key_aux].value)} 
                                    onClick={self.activeSlide.bind(self, { key: dashboards[key_aux].value, index : index})}>
                                    <span className="title">{dashboards[key_aux].name}</span>
                                </div>
                            )
                        }
                    }))
                }
            })
            return (
                <div className="layout">
                    <div className={"loading-panel " + this.state.request_status + " " + (this.props.app.state.panel !== "reservation" ? "hide" : "")}>
                        <div className="bkg-stars">
                            <span 
                                className="figure-1"
                                style={{
                                    background : 'url(' + ROOT_DIR + "uploads/" + this.props.app.state.subdomain + "/logo_old.svg" + ') center center no-repeat',
                                    backgroundSize : 300
                                }} 
                            ></span>
                        </div>
                    </div>
                    <div style={positionLeft(0, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "production", "main-slide")}>
                        <Production
                            request_status={this.state.request_status}
                            response_request={this.state.response_request}
                            panel={this.props.app.state.panel}
                            current_slide={this.state.active_slide.key}
                            current_year={this.props.app.state.current_year}
                            past_year={this.props.app.state.past_year}
                            view_results={this.props.app.state.view_results}
                            app={this.props.app}
                            layout={this}
                            ref={(Production) => { this._Production = Production; }}
                        />
                    </div>
                    <div style={positionLeft(1, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "top-producer", "main-slide")}>
                        <TopProducers
                            request_status={this.state.request_status}
                            response_request={this.state.response_request}
                            panel={this.props.app.state.panel}
                            current_slide={this.state.active_slide.key}
                            current_year={this.props.app.state.current_year}
                            past_year={this.props.app.state.past_year}
                            view_results={this.props.app.state.view_results}
                            ref={(TopProducers) => { this._TopProducers = TopProducers  ; }}
                        />
                    </div>
                    <div style={positionLeft(2, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "reserves", "main-slide")}>
                        <Reserves
                            app={this.props.app}
                            layout={this}
                            ref={(Reserves) => { this._Reserves = Reserves; }}
                        />
                    </div>
                    <div className={"slide-keys " + (this.props.app.state.panel !== "reservation" ? "hide" : "") + " " + this.props.app.state.status_sidebar}>
                        <div className="tabs">
                            <div className={this.state.tab_submodule} onClick={this.activeSubmoduleTab.bind(this)}><Icon type="ellipsis" theme="outlined" /> DASHBOARDS</div>
                            <div className={this.state.tab_filters + this.props.app.hasFilters()} onClick={this.activeFiltersTab.bind(this)}><Icon type="filter" theme="outlined" /> FILTERS ({this.props.app.state.number_filters})</div>
                        </div>
                        <div className={"filters-tab " + this.state.tab_filters}>
                            <FiltersActive 
                                app={this.props.app} 
                                ref={(FiltersActive) => { this._FiltersActive = FiltersActive; }}
                            />
                        </div>
                        <div 
                            className={"content-submodules " + this.state.tab_submodule} 
                            children={this.state.slides_component} />
                    </div>
                </div>
            )
        }else{
            return (<div></div>)
        }
    }
}

export default Layout



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/Layout.js